import { motion } from 'framer-motion'
import { HiLoRulesCSS } from './HiLoRulesCSS.styled'
import { Close } from './HiLoRulesCSS.styled'

export const HiLoRules = ({ layoutId, onClose }) => {
  return (
    <HiLoRulesCSS>
      <motion.div layoutId={layoutId} className='overlay'>
        <Close masking onClick={onClose} />
        <h3 className='rules-header'>Hi-Lo Rules</h3>
        <ul>
          <li>
            <p>Aces are high</p>
          </li>
          <li>
            <p>The deck is reshuffled after each time a direction is selected</p>
          </li>
          <li>
            <p>All winning streaks and rankings can be seen by clicking in the area below the displayed card</p>
          </li>
          <li>
            <p>Winnings and losses are added and deducted from your total balance immediately</p>
          </li>
        </ul>
      </motion.div>
    </HiLoRulesCSS>
  )
}
